// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__23iYw","rightAdornment":"Header_rightAdornment__1IaG9"};